// API END Points
import * as constants from "../utils/constants";
/**---------------Authentication------------------------------ */

export const AddFeedback = `/user/add-inquiry ${constants.POST_RAW}`;
export const FAQ = `default/faq/list ${constants.GET_URL_PARAMS}`;
export const privacyPolicy = `default/privacy-policy ${constants.GET_URL_PARAMS}`;
export const termsAndConditions = `default/terms-conditions ${constants.GET_URL_PARAMS}`;
export const CONTACTUS = `default/contact-us-landing ${constants.POST_RAW}`;
